import Vue from 'vue'
import Toasted from 'vue-toasted'

Vue.use(Toasted,{
    iconPack: 'material',
    theme: 'bubble'
})
// 5uRF9tkZwmqMCuRDmJ6B